import moment from "moment";
import { calculateUnits } from "../../../common/function";

export function formatDuration(ms) {
    const totalSeconds = Math.floor(ms / 1000);

    const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, '0');
    const seconds = String(totalSeconds % 60).padStart(2, '0');

    return `${minutes} mins ${seconds} secs`;
}

export function formatDurationInNumber(ms) {
  const totalSeconds = ms / 1000;
  const hours = totalSeconds / 3600;

  return hours.toFixed(2); // decimal hours
}

let makeHourDataForDoorSensor = (obj, hour, durationMS, day) => {
    if (obj[`${hour}`] === undefined) {
        obj[`${hour}`] = {
            count: 1,
            duration: durationMS,
            date: day
        }
    } else {
        obj[`${hour}`] = {
            count: obj[`${hour}`].count + 1,
            duration: obj[`${hour}`].duration + durationMS,
            date: obj[`${hour}`].date
        }
    }
}
const createSlots = (slotDifference, numSlots) => {


  if (!Number.isInteger(slotDifference) || slotDifference < 1 || slotDifference > 24) {
    throw new Error("Slot interval must be a whole number between 1 and 24 inclusive.");
  }

  const slots = [];

  for (let i = 0; i < numSlots; i++) {
    const hour = i * slotDifference;
    const label = hour;

    slots.push({ time: 0, unit: 0, devices: [], label, unit: 0});
  }

  return slots;
}
const calculateUnitReportHourly = (log, slotDifference) => {
 let numSlots = 24 / slotDifference // Because there are 24 hrs in a day

    let slot = createSlots(slotDifference, numSlots)

    for (let i = 0; i <= log.length; i++) {
      if (log[i + 1] !== undefined) {

        findTimeOfCarbonConsumed(
          { startTime: log[i].ts, endTime: log[i + 1].ts },
          slot,
          log[i].p,
          slotDifference,
          log[i].eu
        );

      }
    }
    return slot
}
const findTimeOfCarbonConsumed = (time, room, p, slotDifference,unitValue) => {
  const startTime = new Date(time.startTime);
  const endTime = new Date(time.endTime);
  if (startTime.getHours() === endTime.getHours()) {
    processTimeSlot(startTime, endTime, room, p, slotDifference,unitValue);
  } else {
    for (let i = startTime.getHours(); i <= endTime.getHours(); i++) {
      if (i === startTime.getHours()) {
        const nextHourStartTime = new Date(startTime).setHours(i + 1, 0, 0, 0);
        processTimeSlot(startTime, nextHourStartTime, room, p, slotDifference,unitValue);
      } else if (i === endTime.getHours()) {
        const slotEndTime = new Date(startTime).setHours(i, 0, 0, 0);
        processTimeSlot(slotEndTime, endTime, room, p, slotDifference,unitValue);
      } else {
        const slotStartTime = new Date(startTime).setHours(i, 0, 0, 0);
        const nextHourStartTime = new Date(startTime).setHours(i + 1, 0, 0, 0);
        processTimeSlot(slotStartTime, nextHourStartTime, room, p, slotDifference,unitValue);
      }
    }
  }
};
const processTimeSlot = (startTime, endTime, room, p, slotDifference,unitValue) => {
  const slotStartTime = new Date(startTime);
  const slotEndTime = new Date(endTime);
  const slotNumber = Math.floor(slotStartTime.getHours() / slotDifference);
  const timeDiff = slotEndTime - slotStartTime;

  room[slotNumber].time += timeDiff;

  const { unitConsumed } = calculateUnits(timeDiff, p,unitValue);
  room[slotNumber].unit += unitConsumed;
};
export const calculateUnitReportHelper = (sortLogs) => {
    let sortAccordingM = {
        0: [],
    };
    for (let p of sortLogs) {
        if (p.m === undefined || p.m === 0) {
            sortAccordingM["0"].push(p);
        } else {
            if (sortAccordingM[`${p.m}`] === undefined) {
                sortAccordingM[`${p.m}`] = [];
            }
            sortAccordingM[`${p.m}`].push(p);
        }
    }
    let allPhase = []
    for (let m in sortAccordingM) {
      let res = calculateUnitReportHourly(sortAccordingM[m], 1);
      allPhase.push(res)
    }
   
    let finalData = {}
    for(let i=0;i<24;i++){
        let index = String(i).length===1?`0${i}`:i
        finalData[index] = {
            time: 0,
            unit: 0,
        }
        finalData[index].unit += allPhase.reduce((acc, phase) => acc + phase[i].unit, 0);
        finalData[index].time += allPhase.reduce((acc, phase) => acc + phase[i].time, 0);
    }
    return {unitData:finalData}
};

export const calculateDoorSensorOpenClose = (openSessions) => {
    let hourLogs = {}
    let rawLogs = []
    for (let session of openSessions) {
        let hour = moment(session.endTime).format('HH')
        let day = moment(session.endTime).format('DD-MM-YYYY')
        let sHour = moment(session.startTime).format('HH')
        if (typeof session.endTime === "string") {
            continue
        }
        if (hour === sHour) {
            let durationMS = (session?.endTime - session?.startTime)
            makeHourDataForDoorSensor(hourLogs, hour, durationMS, day)
        } else {
            // devide duration according to hours
            let startTime = session.startTime;
            let endTime = session.endTime;

            while (startTime < endTime) {
                // end of current hour (exclusive)
                let hourEnd = moment(startTime).startOf('hour').add(1, 'hour').valueOf();

                // clamp to session end
                let sliceEnd = Math.min(hourEnd, endTime);

                let durationMS = sliceEnd - startTime;

                let hourKey = moment(startTime).format('HH');
                let dayKey = moment(startTime).format('DD-MM-YYYY');

                makeHourDataForDoorSensor(hourLogs, hourKey, durationMS, dayKey);

                startTime = sliceEnd;
            }
        }
        rawLogs.push({
            "Open Since": moment(session.startTime).format('DD-MM-YYYY, LT'),
            "Close Since": moment(session.endTime).format('DD-MM-YYYY, LT'),
            "Duration": formatDuration(session.endTime - session.startTime)
        })
    }
    return {
        hourLogs,
        rawLogs
    }
}

export const whenMeterIsOff = (logs) => {
    let hourLogs = {}
    for (let session of logs.filter((log)=>log.s===0)) {
        let hour = moment(session.ts).format('HH')
        if(hourLogs[`${hour}`]===undefined){
            hourLogs[`${hour}`] = 1
        }else{
            hourLogs[`${hour}`] = hourLogs[`${hour}`] + 1
        }
    }
    return {meterOffLogs:hourLogs}
}

export const calculateTemperatureReportHelper = (logs) => {
    let hourLogs = {}
    for (let session of logs) {
        let hour = moment(session.ts).format('HH')
        if(hourLogs[`${hour}`]===undefined){
            hourLogs[`${hour}`] = {
                higestTemp: session.t,
                lowestTemp: session.t,
            }
        }else{
            hourLogs[`${hour}`] = {
                higestTemp:hourLogs[`${hour}`].higestTemp> session.t? hourLogs[`${hour}`].higestTemp: session.t,
                lowestTemp: hourLogs[`${hour}`].lowestTemp< session.t? hourLogs[`${hour}`].lowestTemp: session.t,
            }
        }
    }
    return {temperatureLogsData:hourLogs}
}